import { Breadcrumbs } from "./Breadcrumbs";

export const PageHero = ({ eyebrow, title, description, crumbs }) => (
  <section className="kremes-texture border-b border-dashed border-amber-900/20">
    <div className="mx-auto max-w-6xl px-5 pb-12 pt-12 sm:pb-16 sm:pt-16">
      <Breadcrumbs items={crumbs} />
      <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu">
        {eyebrow}
      </p>
      <h1 className="max-w-3xl font-heading text-4xl font-extrabold leading-[1.1] tracking-tight text-charcoal sm:text-5xl">
        {title}
      </h1>
      {description && (
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-charcoal-muted sm:text-lg">
          {description}
        </p>
      )}
    </div>
  </section>
);
